import React from 'react'
import { Button, Container, Icon, Header, Visibility, Segment } from 'semantic-ui-react'
import { Link } from 'react-router-dom';

import Fade from 'react-reveal/Fade';

// export class DesktopContainer extends Component {
//     render() {
//         return (
//             <div>

//             </div>
//         )
//     }
// }

// export default DesktopContainer


const DesktopContainer = () => (
    <Visibility once={false}
    //   onBottomPassed={this.showFixedMenu}
    //   onBottomPassedReverse={this.hideFixedMenu}
    >
        <Segment inverted textAlign='center' style={{ minHeight: 350 }} vertical>
            <Container text >
            {/* <Header as='h2' content='Machine Learning Studio' inverted style={{ fontSize: '1.7em', fontWeight: 'normal', marginTop: '1.5em', }} /> */}

            {/* <Header as='h1' content='Machine Learning Studio' inverted style={{ fontSize: '4em', fontWeight: 'normal', marginBottom: 0, marginTop: '3em', }} /> */}

                <Fade left cascade>
                <div style={{marginTop: '3em',}}>
                    {/* <Header as='h1' content='Machine Learning Studio' inverted style={{ fontSize: '4em', fontWeight: 'normal', marginBottom: 0, marginTop: '3em', }} /> */}
     
                    {/* <Header as='h1' content='Machine Learning Studio' inverted style={{ fontSize: '4em', fontWeight: 'normal', marginBottom: 0,  }} /> */}
                    {/* <Header as='h1' content='E2E Encryption' inverted style={{ fontSize: '10.5vw', fontWeight: 'normal', marginBottom: '-.5em', textAlign:'left' , minWidth: '50vw'}} />
                    <Header as='h1' content='HIPAA compliant' inverted style={{ fontSize: '10.5vw', fontWeight: 'normal', marginBottom: '-.5em', textAlign:'left' }} />
                    <Header as='h1' content='AI powered' inverted style={{ fontSize: '10.5vw', fontWeight: 'normal', textAlign:'left' }} /> */}

                    
                    <Header as='h1' content='HIPAA compliant' style={{ fontSize: '1.7em', fontWeight: 'normal', marginTop: '1.0em', color:'#FAF0E6',  textAlign:'center' }} />

                    <Header as='h1' content='E2E Encryption'   style={{  fontSize: '1.7em',fontWeight: 'normal', marginTop: '1.0em', color:'#FAF0E6' ,  textAlign:'center'}} />

                    <Header as='h1' content='AI powered'  style={{ fontSize: '1.7em', fontWeight: 'normal', marginTop: '1.0em', color:'#FAF0E6' ,  textAlign:'center'}} />
 



{/* 
                    <h1 style={{ fontSize: '10vw', minWidth:  '80px'}}>
                    E2E Encryption
                                </h1> */}

 
                    </div>
                </Fade>

<br></br>
<br></br>
 
 



                {/* <Button primary size='huge' floated='center'  >
                    <Link name='GetStarted' style={{ marginBottom: '.5em', color: 'white' }} to="/register" as={Link}>
                        Get Started   <Icon name='right arrow' /></Link>
                </Button> */}



            </Container>

            
        </Segment>
    </Visibility>

)


export default DesktopContainer;